import { Button, Box, styled } from '@mui/material'
import useRestore from 'hooks/useRestore'
import { useSearchParams } from 'react-router-dom'

// import { DocListItem } from 'entities/Documents'

const TopArea = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
  display: 'flex',
  justifyContent: 'space-between',
}))

type Props = {
  // documents: DocListItem[] | null
  selectedIDs: string[]
  setOpenDelDialog: (x: boolean) => void
}

function DeletedControlArea({ selectedIDs, setOpenDelDialog }: Props) {
  const [_a, setSearchParams] = useSearchParams()
  const restore = useRestore()

  const selected = Boolean(selectedIDs.length)

  const openDelDocDialog = () => {
    setOpenDelDialog(true)
  }

  const handleRestoreClick = () => {
    restore({
      objectIDs: selectedIDs,
      multi: true,
    }).then((result) => {
      if (result !== 'canceled') {
        setSearchParams((s) => s)
      }
    })
  }

  return (
    <TopArea>
      <Box sx={{ color: 'text.disabled' }}>
        ドキュメントファイルは最終更新日時から31日経過すると自動的にごみ箱へ移動されます。
        <br />
        ごみ箱内のドキュメントファイルは、31日経過すると自動的に完全削除されます。
      </Box>
      <Box sx={{ minWidth: 208 }}>
        <div>
          <Button
            onClick={handleRestoreClick}
            variant="outlined"
            disabled={!selected}
            data-testid="restore-button"
          >
            復元
          </Button>
          <Button
            onClick={openDelDocDialog}
            variant="contained"
            color="secondary"
            disabled={!selected}
            data-testid="delete-button"
          >
            削除
          </Button>
        </div>
      </Box>
    </TopArea>
  )
}

export default DeletedControlArea
